import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";

import "./living.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { BsPlus, BsDash } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { WiDust } from "react-icons/wi";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";

class Living extends Component {
	static contextType = LoadingContext; // ✅ contextType 사용
	state = {
		title: "생활",
		activeItem: "",
		lstEmd: [],
		lstYmd: [],
		lstGb: [],
		tourList: [],
		source:"",
	};

	openSearchWrap = (evt) => {
		$("#livingWrap .itemsWrap").hide();
		$("#livingWrap .searchWrap").show();
		$("#livingWrap .close").show();
		$(".source").show();
		$("#livingWrap .searchWrap").css("top","60px");		

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		let source = "";

		
		if(id==="park"){
			this.getYmd("park_info");		
			this.getGb(id);
			source = "도시공원과";
		}else if(id==="hospital"){
			this.getYmd("medical_info");		
			this.getGb(id);
			source = "감영병관리과";
		}else if(id==="wifi"){
			this.getYmd("wifi_info");		
			//this.getGb(id);
			source = "공공와이파이";
		}else if(id==="tour"){
			this.getTourList();
			source = "기상청";
		}else if(id==="dust"){
			//this.getYmd("dust_info");		
			//this.getGb(id);
			source = "기상청"
		}else if(id==="weather"){
			source = "기상청"
		}else if(id==="bioTop"){
			this.getGb(id);
		}

		this.setState({
			activeItem: id,
			title,
			source,
		});
	};

	closeSearchWrap = () => {
		$("#livingWrap .searchWrap").hide();
		$("#livingWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#livingWrap .close").hide();
		$(".source").hide();
		$("#livingWrap .searchWrap").css("top","");

		//this.selectwelfareSgg.refresh();
		//this.selectwelfareEmd.refresh();

		this.setState({
			activeItem: "",
			title: "생활",
		});		
	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	getYmd = (value) => {
		let lstYmd = [];
		

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					//lstYmd: [{ stdYmd: res[0].stdYmd, stdName: res[0].stdName }, ...lstYmd],
					//lstYmd: [{ stdYmd: "0", stdName: "=== 전체 ===" }, ...lstYmd],
					lstYmd: [...lstYmd],
				});
			},
		});
	};

	getGb = (id) => {
		let lstGb = [];
		

		if(id==="park"){
			lstGb = [
				{facilitiesGb:'근린공원',facilitiesNm:'근린공원'}, 
				{facilitiesGb:'도시농업공원', facilitiesNm:'도시농업공원'},
				{facilitiesGb:'묘지공원', facilitiesNm:'묘지공원'},
				{facilitiesGb:'문화공원', facilitiesNm:'문화공원'},
				{facilitiesGb:'소공원', facilitiesNm:'소공원'},
				{facilitiesGb:'수변공원', facilitiesNm:'수변공원'},
				{facilitiesGb:'어린이공원', facilitiesNm:'어린이공원'},
				{facilitiesGb:'역사공원', facilitiesNm:'역사공원'},
				{facilitiesGb:'주제공원', facilitiesNm:'주제공원'},
				{facilitiesGb:'체육공원', facilitiesNm:'체육공원'}
			];
		}else if(id==="hospital"){			
			lstGb = [
				{facilitiesGb:'종합병원',facilitiesNm:'종합병원'}, 
				{facilitiesGb:'요양병원',facilitiesNm:'요양병원'}, 
				{facilitiesGb:'치과병원',facilitiesNm:'치과병원'}, 
				{facilitiesGb:'정신병원',facilitiesNm:'정신병원'}, 
				{facilitiesGb:'한방병원',facilitiesNm:'한방병원'}, 
				{facilitiesGb:'의원',facilitiesNm:'의원'}, 
				{facilitiesGb:'치과의원',facilitiesNm:'치과의원'},
				{facilitiesGb:'한의원',facilitiesNm:'한의원'}, 
				{facilitiesGb:'부속의원',facilitiesNm:'부속의원'}
			];
		}else if(id==="bioTop"){			
			lstGb = [
				{facilitiesGb:'gjg_biotop',facilitiesNm:'토지이용도'}, 
				{facilitiesGb:'gjg_biotop_outfit',facilitiesNm:'토지피복도'}, 
				{facilitiesGb:'gjg_biotop_vegatation_map',facilitiesNm:'현존식생도'}, 
				{facilitiesGb:'gjg_biotop_type',facilitiesNm:'비오톱 유형도'}, 
				{facilitiesGb:'gjg_biotop_class',facilitiesNm:'비오톱 유형 등급도'}
			];
		}
		if(id==="bioTop"){
			this.setState({
				lstGb: [...lstGb],
			});		
		}else{
			this.setState({
				lstGb: [{ facilitiesGb: "0", facilitiesNm: "=== 전체 ===" }, ...lstGb],
			});	
		}
		
	};

	getTourList() {

		$.ajax({
			url: "/map/getTourList",
			type: "post",
			success: (res) => {
				this.setState({
					tourList: res,
				});
			},
		});
	}

	// 오버레이 클릭 이벤트(모달창 띄움)
	_overlayClickEvent = (ele, id, activeItem, noProps = false ,mapZoom = false) => {
		const { actions, layout, sis } = this.props;

		let overlayElement;
		let crsCode = "EPSG:4326";
		let offset;

		if (activeItem === "park") {
			let parkGb = ele.parkType;
			crsCode = "EPSG:5186";
			let name = "";
			let classNm = "";
			
			switch (parkGb) {
				case "근린공원":
					name = "근린";
					classNm = "tag park";
					break;
				case "도시농업공원":
					name = "도시";
					classNm = "tag park2";
					break;
				case "문화공원":
					name = "문화";
					classNm = "tag park3";
					break;
				case "소공원":
					name = "소";
					classNm = "tag park4";
					break;
				case "수변공원":
					name = "수변";
					classNm = "tag park5";
					break;
				case "어린이공원":
					name = "어린이";
					classNm = "tag park6";
					break;
				case "역사공원":
					name = "역사";
					classNm = "tag park7";
					break;
				case "주제공원":
					name = "주제";
					classNm = "tag park8";
					break;
				case "체육공원":
					name = "체육";
					classNm = "tag park9";
					break;
			}

			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="livingTitle">{ele.parkName}</span>
					<span className={classNm}>{name}</span>
					<span className="livingAddress">
						{ele.parkAddre}
					</span>
				</>
			);
		}else if (activeItem === "hospital") {
			let parkGb = ele.gubun;
			crsCode = "EPSG:5186";
			let name = "";
			let classNm = "";

			switch (parkGb) {
				case "종합병원":
					name = "종합";
					classNm = "tag hospital";
					break;
				case "요양병원":
					name = "요양";
					classNm = "tag hospital2";
					break;
				case "치과병원":
					name = "치과";
					classNm = "tag hospital3";
					break;
				case "정신병원":
					name = "정신";
					classNm = "tag hospital4";
					break;
				case "한방병원":
					name = "한방";
					classNm = "tag hospital5";
					break;
				case "의원":
					name = "의원";
					classNm = "tag hospital6";
					break;
				case "치과의원":
					name = "치과의원";
					classNm = "tag hospital7";
					break;
				case "한의원":
					name = "한의원";
					classNm = "tag hospital8";
					break;
				case "부속의원":
					name = "부속";
					classNm = "tag hospital9";
					break;
			}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="livingTitle">{ele.hospitalNm}</span>
					<span className={classNm}>{name}</span>
					<span className="livingAddress">
						{ele.addr}
					</span>

					<table>
						<tbody>
							<caption>병원종류</caption>
							<tr>
								<th>병원종류</th>
								<td>{ele.gubun ? ele.gubun : "-"}</td>
							</tr>
							<tr>
								<th>전화번호</th>
								<td>{ele.tel ? ele.tel : "-"}</td>
							</tr>							
						</tbody>
					</table>
					{/*<span>병원종류 : {ele.gubun}</span>
					<span>전화번호 : {ele.tel}</span>*/}
				</>
			);
		}else if (activeItem === "wifi") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="livingTitle">{ele.equipNm}</span>
					<span className="livingAddress">
						{ele.address}
					</span>
					<table>
						<caption>설치시설 정보</caption>
						<tbody>
							<tr>
								<th>설치장소명</th>
								<td>{ele.equipNm ? ele.equipNm : "-"}</td>
							</tr>
							<tr>
								<th>설치시설구분</th>
								<td>{ele.equipGbn ? ele.equipGbn : "-"}</td>
							</tr>
							<tr>
								<th>서비스제공사</th>
								<td>{ele.serviceMaker ? ele.serviceMaker : "-"}</td>
							</tr>
						</tbody>
					</table>
				</>
			);
		}else if (activeItem === "weather") {
			const { actions, sis, layout } = this.props;

			const sggName = $("select#selectLivingSgg option:selected").text();
			const locName = "전남광주통합특별시 " + (sggName.length > 4 ? ele.sggNm : sggName + " " + ele.sggNm);
			let mTemp;
			let data = [];

			const params = {
				sggName: sggName.length > 4 ? "" : sggName,
				umdName: ele.sggNm,
			};

			$.ajax({
				url: "/map/getMMTemperature",
				type: "post",
				data: params,
				async: false,
				success: (res) => {
					mTemp = res;
					data = res.item;
				},
			});

			const modal = layout.get("weatherModal");
			modal.setData(locName, mTemp, data);

			$("#weatherModal").show();
		} else {
			noProps = false;
			id = `living_dust_removeOverlay`;
			$(`[id*=living_dust_removeOverlay]`).remove();
			crsCode = "EPSG:5186";
			offset = [10, -100];

			const dustList = this.dustAjax(ele.sggNm);

			let pm10Color = "good",
				pm25Color = "good",
				no2Color = "good",
				coColor = "good",
				o3Color = "good",
				so2Color = "good";
			let pm10Text = "좋음",
				pm25Text = "좋음",
				no2Text = "좋음",
				coText = "좋음",
				o3Text = "좋음",
				soText = "좋음";
			// 미세먼지
			if (dustList[0].pm10Value > 30) {
				pm10Color = "normal";
				pm10Text = "보통";
			}
			if (dustList[0].pm10Value > 80) {
				pm10Color = "bad";
				pm10Text = "나쁨";
			}
			if (dustList[0].pm10Value > 150) {
				pm10Color = "emergency";
				pm10Text = "매우나쁨";
			}

			// 초미세먼지
			if (dustList[0].pm25Value > 15) {
				pm25Color = "normal";
				pm25Text = "보통";
			}
			if (dustList[0].pm25Value > 35) {
				pm25Color = "bad";
				pm25Text = "나쁨";
			}
			if (dustList[0].pm25Value > 75) {
				pm25Color = "emergency";
				pm25Text = "매우나쁨";
			}

			// 이산화질소
			if (parseFloat(dustList[0].no2Value) > 0.03) {
				no2Color = "normal";
				no2Text = "보통";
			}
			if (parseFloat(dustList[0].no2Value) > 0.06) {
				no2Color = "bad";
				no2Text = "나쁨";
			}
			if (parseFloat(dustList[0].no2Value) > 0.2) {
				no2Color = "emergency";
				no2Text = "매우나쁨";
			}

			// 일산화탄소
			if (parseFloat(dustList[0].coValue) > 2) {
				coColor = "normal";
				coText = "보통";
			}
			if (parseFloat(dustList[0].coValue) > 9) {
				coColor = "bad";
				coText = "나쁨";
			}
			if (parseFloat(dustList[0].coValue) > 15) {
				coColor = "emergency";
				coText = "매우나쁨";
			}

			// 오존
			if (parseFloat(dustList[0].o3Value) > 0.03) {
				o3Color = "normal";
				o3Text = "보통";
			}
			if (parseFloat(dustList[0].o3Value) > 0.09) {
				o3Color = "bad";
				o3Text = "나쁨";
			}
			if (parseFloat(dustList[0].o3Value) > 0.15) {
				o3Color = "emergency";
				o3Text = "매우나쁨";
			}

			// 아황산가스
			if (parseFloat(dustList[0].so2Value) > 0.02) {
				so2Color = "normal";
				soText = "보통";
			}
			if (parseFloat(dustList[0].so2Value) > 0.05) {
				so2Color = "bad";
				soText = "나쁨";
			}
			if (parseFloat(dustList[0].so2Value) > 0.15) {
				so2Color = "emergency";
				soText = "매우나쁨";
			}

			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="livingTitle dustTitle">측정소명 : {ele.sggNm}</span>

					<table>
						<caption>미세먼지 정보</caption>
						<thead>
							<tr>
								<th>항목</th>
								<th>등급</th>
								<th>측정값</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th>미세먼지(PM10)</th>
								<td>
									<span className={`tag ${pm10Color}`}>{pm10Text}</span>
								</td>
								<td>{`${dustList[0].pm10Value}㎍/㎥(1h) ${dustList[0].pm10ValueAvg}㎍/㎥(24h)`}</td>
							</tr>
							<tr>
								<th>초미세먼지(PM2.5)</th>
								<td>
									<span className={`tag ${pm25Color}`}>{pm25Text}</span>
								</td>
								<td>{`${dustList[0].pm25Value}㎍/㎥(1h) ${dustList[0].pm25ValueAvg}㎍/㎥(24h)`}</td>
							</tr>
							<tr>
								<th>이산화질소</th>
								<td>
									<span className={`tag ${no2Color}`}>{no2Text}</span>
								</td>
								<td>{`${dustList[0].no2Value}ppm`}</td>
							</tr>
							<tr>
								<th>일산화탄소</th>
								<td>
									<span className={`tag ${coColor}`}>{coText}</span>
								</td>
								<td>{`${dustList[0].coValue}ppm`}</td>
							</tr>
							<tr>
								<th>오존</th>
								<td>
									<span className={`tag ${o3Color}`}>{o3Text}</span>
								</td>
								<td>{`${dustList[0].o3Value}ppm`}</td>
							</tr>
							<tr>
								<th>아황산가스</th>
								<td>
									<span className={`tag ${so2Color}`}>{soText}</span>
								</td>
								<td>{`${dustList[0].so2Value}ppm`}</td>
							</tr>
						</tbody>
					</table>
				</>
			);
		}

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			crsCode,
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
			offsetValue: offset,
			mapZoom,
		});
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");

		if (activeItem === "park") col = "parkName";
		else if (activeItem === "hospital") col = "hospitalNm";
		else if (activeItem === "wifi") col = "equipNm";
		else if (activeItem === "weather") col = "sgg";


		let id = `living_${activeItem ? activeItem : "dust"}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					//if (activeItem !== "park") {
					//	const id = item.getId();

					//	if (id.indexOf("dust") > -1) arrOverlays.push(item);
					//} else {
						arrOverlays.push(item);
					//}
				}
			}
		});
		if(activeItem === "weather"|| activeItem.trim() === ""){
			arrOverlays.length = 0; // 배열 초기화
		}
		if (arrOverlays.length > 1) {
			/*if(col === "parkName") {
			   arrOverlays.forEach((item) => {
				  const props = item.getProperties();
				  if(props[col] === ele.parkName) {
					 this._overlayClickEvent(props, id, activeItem, true);
					 sis.sisMap.map.removeOverlay(overlay);
				  }
			   });
			}else if(col === "hospitalNm") {
				arrOverlays.forEach((item) => {
				   const props = item.getProperties();
				   if(props[col] === ele.hospitalNm) {
					  this._overlayClickEvent(props, id, activeItem, true);
					  sis.sisMap.map.removeOverlay(overlay);
				   }
				});
			}else if(col === "equipNm") {
				arrOverlays.forEach((item) => {
				   const props = item.getProperties();
				   if(props[col] === ele.equipNm) {
					  this._overlayClickEvent(props, id, activeItem, true);
					  sis.sisMap.map.removeOverlay(overlay);
				   }
				});
			} else {*/
			   // if (true) {
			   // 오버레이 생성
			   const overlayElement = document.createElement("div");
			   document.body.appendChild(overlayElement);
			   overlayElement.className = "overlaySelector";
			   overlayElement.id = "overlaySelector";
   
			   let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
   
			   if (overlay) sis.sisMap.map.removeOverlay(overlay);
			   overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			   overlay.setPosition(pos);
			   $(overlayElement).parent().css("z-index", 9999);
   
			   arrOverlays.forEach((item) => {
				  const props = item.getProperties();
   
				  if (props[col]) {
					 const element = document.createElement("div");
					 element.innerText = props[col];
					 $(overlayElement).append(element);
   
					 $(element).on("click", () => {
						this._overlayClickEvent(props, id, activeItem, true);
						sis.sisMap.map.removeOverlay(overlay);
					 });
				  }
   
				  // $(overlayElement).append(`<div>${props.buildNm}</div>`);
			   });
			//}
		 } else {
			this._overlayClickEvent(ele, id, activeItem);
		 }

		return;
	};

	// 미세먼지 ajax
	dustAjax = (cityNm) => {
		let dustList = [];

		const params = {
			cityNm: cityNm,
		};

		$.ajax({
			url: "/map/getDustDetail",
			type: "post",
			data: params,
			async: false,
			success: (res) => {
				dustList = res;
			},
		});

		return dustList;
	};

	// 미세먼지 오버레이 생성
	createDustOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;
		let dustList = this.dustAjax("");

		data.forEach((ele, idx) => {
			let overlayElement;

			dustList.map((item, idx) => {
				if (item.cityNm === ele.sggNm) {
					let dustColor = "#2359c4";
					if (item.pm10Value > 30) dustColor = "#01B56E";
					if (item.pm10Value > 80) dustColor = "#F5C932";
					if (item.pm10Value > 150) dustColor = "#DA3438";

					overlayElement = (
						<>
							<WiDust className="image" size="30px" />
							<span className={activeItem}>{item.cityNm}</span>
							<span className="dustValue">{`${item.pm10Value}㎍/㎥`}</span>
						</>
					);

					actions.addResultOverlay({
						element: overlayElement,
						data: ele,
						id: `${id}_${ele.sggCd}`,
						className: "livingOverlayWrap",
						onClick: this.overlayClickEvent,
						crsCode: "EPSG:5186",
						isDust: true,
						color: dustColor,
					});
				}
			});
		});
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		const sggCode = $("select#selectLivingSgg").val();
		const sggName = $("select#selectLivingSgg option:selected").text();


		let weatherData = [];

		if(activeItem==="weather"){
			const params = {
				sggName: sggCode === "0" ? "" : sggName,
			};
			$.ajax({
				url: "/map/getWeatherList",
				type: "post",
				data: params,
				async: false,
				success: (res) => {
					weatherData = res;
				},
			});
		}else if (activeItem != "dust" && activeItem != "tour"  ) {
			$(".tabWrap .tab.active .searchWrap .listWrap").remove();
			$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + data.length.toLocaleString() + "</a>건</span></div>");
		}



		data.forEach((ele, idx) => {
			let overlayElement;

			if (activeItem === "park") {
				let parkGb = ele.parkType;
				let name = "";
				let classNm = "";

				switch (parkGb) {
					case "근린공원":
						name = "근린";
						classNm = "tag park";
						break;
					case "도시농업공원":
						name = "도시";
						classNm = "tag park2";
						break;
					case "문화공원":
						name = "문화";
						classNm = "tag park3";
						break;
					case "소공원":
						name = "소";
						classNm = "tag park4";
						break;
					case "수변공원":
						name = "수변";
						classNm = "tag park5";
						break;
					case "어린이공원":
						name = "어린이";
						classNm = "tag park6";
						break;
					case "역사공원":
						name = "역사";
						classNm = "tag park7";
						break;
					case "주제공원":
						name = "주제";
						classNm = "tag park8";
						break;
					case "체육공원":
						name = "체육";
						classNm = "tag park9";
						break;
				}

				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm}  style={{marginRight:"3px"}}>{name}</span>
							{ele.parkName}
						</span>
					</>
				);

				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.parkName}</span>`);
				
			} else if (activeItem === "hospital") {
				let parkGb = ele.gubun;				
				let name = "";
				let classNm = "";

				switch (parkGb) {
				case "종합병원":
					name = "종합";
					classNm = "tag hospital";
					break;
				case "요양병원":
					name = "요양";
					classNm = "tag hospital2";
					break;
				case "치과병원":
					name = "치과";
					classNm = "tag hospital3";
					break;
				case "정신병원":
					name = "정신";
					classNm = "tag hospital4";
					break;
				case "한방병원":
					name = "한방";
					classNm = "tag hospital5";
					break;
				case "의원":
					name = "의원";
					classNm = "tag hospital6";
					break;
				case "치과의원":
					name = "치과의원";
					classNm = "tag hospital7";
					break;
				case "한의원":
					name = "한의원";
					classNm = "tag hospital8";
					break;
				case "부속의원":
					name = "부속";
					classNm = "tag hospital9";
					break;
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm} style={{marginRight:"3px"}}>{name}</span>
							{ele.hospitalNm}
							</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.hospitalNm}</span>`);
			} else if (activeItem === "wifi") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.equipNm}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.equipNm}</span>`);
			} else if (activeItem === "weather") {
				weatherData.map((item) => {
					if (item.sgg === ele.sggNm) {
						
						console.log(item);
	
						overlayElement = (
							<>
								<span className={activeItem}>{item.sgg}</span>
								<div className={`image a${item.sky}`}></div>
								<span className="temperature">{item.tmp}</span>
							</>
						);
	
						actions.addResultOverlay({
							element: overlayElement,
							data: ele,
							id: `${id}_${ele.sggCd}`,
							className: "weatherOverlayWrap",
							crsCode: "EPSG:5186",
							onClick: this.overlayClickEvent,
							minZoom: 6,
							maxZoom: 10,
						});
					}
				});
			}
			else if (activeItem === "tour") {
				const weather = ele.cdesName;
				let weatherClass = this.getWratherClass(weather);
				let spotName = ele.spotNm.split(")");
				overlayElement = (
					<>
						<div
					style={{ cursor: "Pointer" }}
					onClick={(evt) => {
						if (!$(evt.target).hasClass("close") && "svg,path".indexOf(evt.target.tagName) === -1) {
							this.createWearherDetail(ele);
						}
					}}
				>
					<div
						className="sisOverlayClose tourOverlayClose"
						onClick={() => {
							$(`#${id}_${ele.spotAreaId}`).hide();
						}}
					>
						<MdClose size="20px" />
					</div>
					<div className="sisOverlayTitleWrap">
						<span className="sisOverlayTitle">{spotName[1]}</span>
					</div>
					<div className="tourContentsWrap">
						<div className={`image weather ${weatherClass}`}></div>
						<div className="tourWeather">
							<span className="tag police2">{spotName[0].replace("(", "")}</span>
							<span
								style={{
									display: "block",
									width: "100%",
									fontSize: "10pt",
									fontWeight: "bold",
									color: "#2359c4",
								}}
							>
								{ele.th3} ℃
							</span>
						</div>
					</div>
				</div>
					</>
				);
			}
			/*if(activeItem == "park" || activeItem == "hospital" || activeItem == "wifi"){
				actions.addResultOverlay({
					element: overlayElement,
					data: ele,
					crsCode: "EPSG:5186",
					id: `${id}_${ele.gid}`,
					className: "livingOverlayWrap",
					onClick: this.overlayClickEvent,
					minZoom: 6,
					maxZoom: 10,
				});
			}else if (activeItem == "tour"){
				actions.addResultOverlay({
					element: overlayElement,
					data: ele,
					id: `${id}_${ele.spotAreaId}`,
					className: "livingOverlayWrap",
				});
			}*/

			let overlayConfig = {
				element: overlayElement,
				data: ele,
				
			};
			
			// "weather"일 경우 actions.addResultOverlay() 호출하지 않음
			if (activeItem !== "weather") {
				if (["park", "hospital", "wifi"].includes(activeItem)) {
					Object.assign(overlayConfig, {
						className: "livingOverlayWrap",
						crsCode: "EPSG:5186",
						id: `${id}_${ele.gid}`,
						onClick: this.overlayClickEvent,
						minZoom: 6,
						maxZoom: 10,
					});
				} else if (activeItem === "tour") {
					Object.assign(overlayConfig, {
						className: "tourOverlayWrap",
						id: `${id}_${ele.spotAreaId}`
					});
					
				}
			
				actions.addResultOverlay(overlayConfig);
			}
			
		});

		data.forEach((ele, idx) => {
			let overlayElement;
			if (activeItem==="wifi") {
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.equipNm}</span>`);

				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						   data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						   data-id='${id}' 
						   data-active-item='${activeItem}'>
					  ${ele.equipNm}
					</span>`
				  );
			} else if (activeItem==="hospital"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						   data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						   data-id='${id}' 
						   data-active-item='${activeItem}'>
					  ${ele.hospitalNm}
					</span>`
				  );
			}	else if (activeItem==="park"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						   data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						   data-id='${id}' 
						   data-active-item='${activeItem}'>
					  ${ele.parkName}
					</span>`
				  );
			}

			
		});

		$(".tabWrap .tab.active .searchWrap .listWrap").on("click", "span", (event) => {
			const target = $(event.currentTarget);
		
			const eleAttr = target.attr("data-ele");
			const id = target.attr("data-id")+"_removeOverlay";
			const activeItem = target.attr("data-active-item");
		
			if (!eleAttr) {
				console.error("data-ele 값이 없습니다.");
				return;
			}
		
			try {
				// ✅ JSON.parse() 한 번만 실행
				const ele = JSON.parse(eleAttr);
				
				// ✅ `this._overlayClickEvent()`를 호출하도록 변경 (화살표 함수 덕분에 this 유지됨)
				if (typeof this._overlayClickEvent === "function") {
					const mapZoom = true;
					const noProps = false;
					this._overlayClickEvent(ele, id, activeItem,noProps,mapZoom);
				} else {
					console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
				}
			} catch (error) {
				console.error("JSON 파싱 오류:", error);
			}
		});

		if(activeItem === "park" || activeItem === "hospital"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","270px");
		}else if(activeItem === "wifi"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","230px");
		}
	};

	// 트리 범례 생성
	createTreeLegend = (props ) => {
		const { activeItem } = this.state;

		if (activeItem === "park") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag park">
								근린
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								근린공원
							</span>

							<span style={{ display: "inline-block" }} className="tag park2">
								도시
							</span>
							<span style={{ display: "inline-block" }} className="text">
								도시농업공원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag park3">
								묘지
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								묘지공원
							</span>

							<span style={{ display: "inline-block" }} className="tag park4">
								문화
							</span>
							<span style={{ display: "inline-block" }} className="text">
								문화공원
							</span>
							<br />

							<span style={{ display: "inline-block",marginRight: "20px", }} className="tag park5">
								소
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "60px",
								}}
								className="text"
							>
								소공원
							</span>

							<span style={{ display: "inline-block" }} className="tag park6">
								수변
							</span>
							<span style={{ display: "inline-block" }} className="text">
								수변공원
							</span>
							<br />

							<span style={{ display: "inline-block", marginRight: "0px",}} className="tag park7">
								어린이
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "40px",
								}}
								className="text"
							>
								어린이공원
							</span>

							<span style={{ display: "inline-block" }} className="tag park8">
								역사
							</span>
							<span style={{ display: "inline-block" }} className="text">
								역사공원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag park9">
								주제
							</span>
							<span style={{ display: "inline-block", marginRight: "52px"}} className="text">
								주제공원
							</span>

							<span style={{ display: "inline-block" }} className="tag park10">
								체육
							</span>
							<span style={{ display: "inline-block" }} className="text">
								채육공원
							</span>
						</div>
					</div>
					
				</>
				
			);
			
		} else if (activeItem === "hospital") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag hospital">
								종합
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								종합병원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital2">
								요양
							</span>
							<span style={{ display: "inline-block" }} className="text">
								요양병원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital3">
								치과
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								치과병원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital4">
								정신
							</span>
							<span style={{ display: "inline-block" }} className="text">
								정신병원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital5">
								한방
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								한방병원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital6">
								의원
							</span>
							<span style={{ display: "inline-block" }} className="text">
								의원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital7">
								치과의원
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "26px",
								}}
								className="text"
							>
								치과의원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital8">
								한의원
							</span>
							<span style={{ display: "inline-block" }} className="text">
								한의원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital9">
								부속
							</span>
							<span style={{ display: "inline-block" }} className="text">
								부속의원
							</span>
						</div>
					</div>
					
				</>
				
			);
			
		} else if (activeItem === "tour") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span className="tag veryGood">매우좋음</span>
							<br />
							<span className="text">야외관광 활동을 하기에 매우 적합한 날씨</span>

							<span className="tag good">좋음</span>
							<br />
							<span className="text">야외관광을 하기에 적합한 날씨</span>

							<span className="tag normal">보통</span>
							<br />
							<span className="text">비, 기온 등 날씨 관광에 주의해서 선택적 야외관광을 해야 하는 날씨</span>

							<span className="tag bad">나쁨</span>
							<br />
							<span className="text">야외관광 활동을 하기 적합하지 않은 날씨</span>

							<span className="tag emergency">특보발령주의</span>
							<br />
							<span className="text">기상특보 발효 지역으로 피해예방 사전준비가 필요한 날씨</span>

							<span style={{ textAlign: "right" }} className="text">
								제공 : 기상청
							</span>
						</div>
					</div>
				</>
				
			);
			
		} else if (activeItem === "") {
			return (
				<div className="legendWrap">
					<div
						className="legendToggle"
						onClick={(e) => {
							$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
							$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
						}}
					>
						<BsPlus className="legendVisible hide" size="18px" />
						<BsDash className="legendVisible" size="18px" />
					</div>

					<span className="legendTitle">
						<AiOutlineUnorderedList size="15px" />
						범례
					</span>

					<div
						className="legendContents"
						style={{
							textAlign: "center",
						}}
					>
						<img src="/sis/images/map/environment/exDust.png" alt="미세먼지 범례" />
					</div>
				</div>
			);
		}else if (activeItem === "bioTop") {
			let legendUrl = "";
			if(props === "gjg_biotop"){
				legendUrl = "/map/proxy/wms.do?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image%2Fpng&LAYER=sde%3Agjg_biotop&width=35&height=25&legend_options=forceLabels:on";
			}else if(props === "gjg_biotop_outfit"){
				legendUrl = "/map/proxy/wms.do?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image%2Fpng&LAYER=sde%3Agjg_biotop_outfit&width=35&height=25&legend_options=forceLabels:on";
			}else if(props === "gjg_biotop_vegatation_map"){
				legendUrl = "/map/proxy/wms.do?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image%2Fpng&LAYER=sde%3Agjg_biotop_vegatation_map&width=35&height=25&legend_options=forceLabels:on";
			}else if(props === "gjg_biotop_type"){
				legendUrl = "/map/proxy/wms.do?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image%2Fpng&LAYER=sde%3Agjg_biotop_type&width=35&height=25&legend_options=forceLabels:on";
			}else if(props === "gjg_biotop_class"){
				legendUrl = "/map/proxy/wms.do?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image%2Fpng&LAYER=sde%3Agjg_biotop_class&width=35&height=25&legend_options=forceLabels:on";
			}

			return (
				<div className="legendWrap">
					<div
						className="legendToggle"
						onClick={(e) => {
							$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
							$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
						}}
					>
						<BsPlus className="legendVisible hide" size="18px" />
						<BsDash className="legendVisible" size="18px" />
					</div>

					<span className="legendTitle">
						<AiOutlineUnorderedList size="15px" />
						범례
					</span>

					<div
						className="legendContents"
						style={{
							textAlign: "center",
						}}
					>
						<img src={legendUrl} alt="도시생태현황지도 범례" />
					</div>
				</div>
			);
		} 
		
	};

	createTreeItem = (props) => {
		const id = props.data[0].courseId;
		const title = props.data[0].courseNm;

		return (
			<>
				<div className="legendWrap">
					<div
						className="legendToggle"
						onClick={(e) => {
							$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
							$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
						}}
					>
						<BsPlus className="legendVisible hide" size="18px" />
						<BsDash className="legendVisible" size="18px" />
					</div>

					<span className="legendTitle">
						<AiOutlineUnorderedList size="15px" />
						범례
					</span>

					<div className="legendContents">
						<span className="tag veryGood">매우좋음</span>
						<br />
						<span className="text">야외관광 활동을 하기에 매우 적합한 날씨</span>

						<span className="tag good">좋음</span>
						<br />
						<span className="text">야외관광을 하기에 적합한 날씨</span>

						<span className="tag normal">보통</span>
						<br />
						<span className="text">비, 기온 등 날씨 관광에 주의해서 선택적 야외관광을 해야 하는 날씨</span>

						<span className="tag bad">나쁨</span>
						<br />
						<span className="text">야외관광 활동을 하기 적합하지 않은 날씨</span>

						<span className="tag emergency">특보발령주의</span>
						<br />
						<span className="text">기상특보 발효 지역으로 피해예방 사전준비가 필요한 날씨</span>

						<span style={{ textAlign: "right" }} className="text">
							제공 : 기상청
						</span>
					</div>
				</div>
			</>
		);
	};

	getWratherClass = (weather) => {
		let weatherClass = "";
		switch (weather) {
			case "맑음":
				weatherClass = "mSunny";
				break;
			case "구름조금":
				weatherClass = "mLittleCloudy";
				break;
			case "구름많음":
				weatherClass = "mCloudy";
				break;
			case "흐림":
				weatherClass = "mGrayDay";
				break;
			case "비":
				weatherClass = "mRain";
				break;
			case "비눈":
				weatherClass = "mRainSnow";
				break;
			case "눈비":
				weatherClass = "mSnowRain";
				break;
			case "눈":
				weatherClass = "mSnow";
				break;
		}

		return weatherClass;
	};

	createWearherDetail = (ele) => {
		const { layout } = this.props;
		const date = new Date();
		const params = {
			spotAreaId: ele.spotAreaId,
			srchDate: date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate()),
		};
		let data = [];
		$.ajax({
			url: "/map/getTourDetail",
			type: "post",
			data: params,
			async: false,
			success: (res) => {
				data = res;
			},
		});

		// modal.show();
		const modal = layout.get("weatherDetailModal");
		modal.setData(data, ele.spotAreaId);
		$("#weatherDetailModal").show();

	};


	// 검색
	search = async (evt) => {
		
		const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	setLoading(true); // 예제: 로딩 상태 변경
		$(".layerOpen").css("display","block");
		const { activeItem } = this.state;
		const { actions, sis } = this.props;
		const { sisLayer } = this.props.sis;
		let stdYmd = document.querySelector("select#selectLivingStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value ;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}
		

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 1000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		};
		  if(activeItem==="park" || activeItem === "hospital" || activeItem==="wifi"){
			// 비동기적으로 처리할 함수
			await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기
		}
		 

		let title = "";
		let data = [];
		//let stdYmd = "";
		let guBun = "0";
		let tagId = "";
		if(activeItem===""){
			tagId = "dust";
		}
		
		if(activeItem==="park" || activeItem === "hospital"){
			stdYmd = $("select#selectLivingStdYmd").val() || $("select#selectLivingStdYmd option:first").val() || "0";
			guBun = $("select#selectLivingGb").val();
		}else if (activeItem==="wifi"){
			stdYmd = $("select#selectLivingStdYmd").val() || $("select#selectLivingStdYmd option:first").val() || "0";
			guBun = "0";
		}

		if(guBun==null){
			guBun = "0";
		}
		if(activeItem === "weather"){

		}
		let params = {
			sggCode: $("select#selectLivingSgg").val(),
			emdCode: $("select#selectLivingEmd").val(),
			stdYmd: stdYmd,
			guBun: guBun,
		};
		//console.log(guBun);
		let color = "#ff0000";
		let url = "";
		let legend = "";
		let crsCode = "EPSG:4326";
		let opacity = 1;
		let id = `living_${activeItem}`;
		let layerName = "";
		let type = "point";

		if (activeItem === "wifi") {
			title = "와이파이설치현황";
			crsCode = "EPSG:5186";
			color = "#cddc39";
			url = "/map/selectWifiInfo";
			//legend = this.createTreeLegend();
		} else if (activeItem === "park") {
			title = "공원";
			crsCode = "EPSG:5186";
			color = "#cddc39";
			url = "/map/selectParkInfo";
			legend = this.createTreeLegend();
		} else if (activeItem === "hospital") {
			title = "의료시설 현황";
			crsCode = "EPSG:5186";
			color = "#ff5722";
			url = "/map/selectHospitalInfo";
			legend = this.createTreeLegend();
		}  else if (activeItem === "weather") {
			title = "기상";
			color = "#d3362d";
			url = "/map/selectWeather";
			crsCode = "EPSG:5186";
			legend = this.createTreeLegend();
		}else if (activeItem === "bioTop") {
			title = "생태현황지도";
			color = "#d3362d";
			layerName = $("select#selectLivingGb").val();
			type = "geoserver";
			//url = "/map/selectWeather";
			//crsCode = "EPSG:5186";
			legend = this.createTreeLegend(layerName);
		} else {
			title = "미세먼지";
			color = "#cddc39";
			url = "/map/selectDust";
			crsCode = "EPSG:5186";
			opacity = 0;
			id = `living_dust`;
			legend = this.createTreeLegend();

			$(".btnFullScreen").click();
		}
		if(activeItem === "tour"){
			$.ajax({
				url: "/map/getTourInformation",
				type: "post",
				data: {
					id : evt,
				},
				success: (res) => {
					if (res.length > 0) {
						const id = res[0].courseId;
						const lyr = sisLayer.getLayerById(`living_${evt}`);
	
						if (lyr) {
							actions.deleteResult({
								id: `living_${evt}`,
								refresh: true,
							});
						}
	
						const treeItem = this.createTreeItem({
							data: res,
							id: `living_${evt}`,
						});
						legend = this.createTreeLegend();
						actions.addResultItem({
							//data: legend,
							id: `living_${evt}`,
							title: res[0].courseNm,
							closeEvent: actions.deleteResult,
							checkboxEvent: actions.resultCheckboxHandler,
						});
						actions.addResultLayer({
							data: res,
							id: `living_${evt}`,
							type: "polyline",
							callback: () => {
								requestAnimationFrame(() => {
									setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
								  });
							  }
						});
	
						this.createOverlay(res, `living_${evt}`);
					}
				},
			});
		}else{
			if(type!=="geoserver"){

				$.ajax({
					url,
					type: "post",
					data: params,
					success: (res) => {
						data = res.items ? res.items : res;
		
						if (data.length === 0) {
							alert("검색결과가 없습니다.");
							setLoading(false);
							return;
						}
		
						if (res.wkt) {
							const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
							feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
							const extent = feature.getGeometry().getExtent();
		
							sis.sisMap.view.fit(extent);
						}
		
						const lyr = sis.sisLayer.getLayerById(id);
		
						if (lyr) {
							actions.deleteResult({
								id,
								refresh: true,
							});
						}
		
						// 트리아이템 생성
						actions.addResultItem({
							data: legend,
							id,
							title,
							closeEvent: actions.deleteResult,
							checkboxEvent: actions.resultCheckboxHandler,
						});
		
						// 레이어 생성
						actions.addResultLayer({
							data,
							id,
							type: type,
							color,
							crsCode,
							opacity,
							callback: () => {
								requestAnimationFrame(() => {
									setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
								  });
							  }
						});
		
						// 오버레이 생성
						if (tagId != "dust") {
							this.createOverlay(data, id);
						} else {
							this.createDustOverlay(data, id);
						}
					},
				});
			}else{
				id = layerName;
				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});
				
				// 레이어 생성
				actions.addResultLayer({
					data,
					id,
					type: type,
					color,
					crsCode,
					opacity,
					layerName,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
						  });
					  },
					/*clickCallback: (featureProps) => {
						console.log("클릭된 Feature 데이터:", featureProps);
						//alert(`선택한 데이터: ${featureProps.manCnt ?? featureProps.womanCnt ?? featureProps.totalCnt ?? "정보 없음"}`);
						const currentLayerId = this.getLatestLayerId();
						this._overlayClickEvent(featureProps, featureProps.id,currentLayerId)
					}*/
				});
			}
		}
		
	};

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;

		if (activeItem.indexOf("park") > -1) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectLivingStdYmd"
							ref={(ref) => (this.selectwelfareStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectLivingSgg"
							className="select"
							items={lstSgg}
							/*defaultValue={defaultSggCd}*/
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectLivingEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">공원종류</span>
						<SisSelect
							id="selectLivingGb"							
							className="select"
							mapping={{
								key: "facilitiesGb",
								text: "facilitiesNm",
							}}
							items={this.state.lstGb}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}else if ("hospital".indexOf(activeItem) > -1) {
					searchElement = (
						<>
							<div className="inputWrap">
								<span className="selectTitle">기준년도</span>
								<SisSelect
									id="selectLivingStdYmd"
									//ref={(ref) => (this.selectwelfareStdYmd = ref)}
									className="select"
									items={this.state.lstYmd}
									mapping={{
										key: "stdYmd",
										text: "stdName",
									}}
									
								/>
							</div>
							
							<div className="inputWrap">
								<span className="selectTitle">구명</span>
								<SisSelect
									id="selectLivingSgg"
									ref={(ref) => (this.selectwelfareSgg = ref)}
									className="select"
									items={lstSgg}
									/*defaultValue={defaultSggCd}*/
									mapping={{
										key: "sggCd",
										text: "sggNm",
									}}
									onChange={this.getEmd}
									onLoaded={this.getEmd}
								/>
							</div>
							<div className="inputWrap">
								<span className="selectTitle">동명</span>
								<SisSelect
									id="selectLivingEmd"
									ref={(ref) => (this.selectwelfareEmd = ref)}
									className="select"
									mapping={{
										key: "emdCd",
										text: "emdNm",
									}}
									items={this.state.lstEmd}
								/>
							</div>
							<div className="inputWrap">
								<span className="selectTitle">병원종류</span>
								<SisSelect
									id="selectLivingGb"
									ref={(ref) => (this.selectwelfareGb = ref)}
									className="select"
									mapping={{
										key: "facilitiesGb",
										text: "facilitiesNm",
									}}
									items={this.state.lstGb}
								/>
							</div>
							
							<div className="btnWrap">
								<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
									검색
								</button>
							</div>
						</>
					);
				}else if ("wifi".indexOf(activeItem) > -1) {
					searchElement = (
						<>
							<div className="inputWrap">
								<span className="selectTitle">기준년도</span>
								<SisSelect
									id="selectLivingStdYmd"
									ref={(ref) => (this.selectwelfareStdYmd = ref)}
									className="select"
									mapping={{
										key: "stdYmd",
										text: "stdName",
									}}
									items={this.state.lstYmd}
								/>
							</div>
							
							<div className="inputWrap">
								<span className="selectTitle">구명</span>
								<SisSelect
									id="selectLivingSgg"
									ref={(ref) => (this.selectwelfareSgg = ref)}
									className="select"
									items={lstSgg}
									/*defaultValue={defaultSggCd}*/
									mapping={{
										key: "sggCd",
										text: "sggNm",
									}}
									onChange={this.getEmd}
									onLoaded={this.getEmd}
								/>
							</div>
							<div className="inputWrap">
								<span className="selectTitle">동명</span>
								<SisSelect
									id="selectLivingEmd"
									ref={(ref) => (this.selectwelfareEmd = ref)}
									className="select"
									mapping={{
										key: "emdCd",
										text: "emdNm",
									}}
									items={this.state.lstEmd}
								/>
							</div>							
							<div className="btnWrap">
								<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
									검색
								</button>
							</div>
						</>
					);
				} else if ("weather".indexOf(activeItem) > -1) {
					searchElement = (
						<>
							<div className="inputWrap">
								<span className="selectTitle">구명</span>
								<SisSelect
									id="selectLivingSgg"
									className="select"
									items={lstSgg}
									defaultValue={0}
									mapping={{
										key: "sggCd",
										text: "sggNm",
									}}
									onChange={this.getEmd}
									onLoaded={this.getEmd}
								/>
							</div>
							
		
							<div className="btnWrap">
								<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
									검색
								</button>
							</div>
						</>
					);
				} else if ("bioTop".indexOf(activeItem) > -1) {
					searchElement = (
						<>
							<div className="inputWrap">
								<span className="selectTitle">주제도</span>
								<SisSelect
									id="selectLivingGb"							
									className="select"
									mapping={{
										key: "facilitiesGb",
										text: "facilitiesNm",
									}}
									items={this.state.lstGb}
								/>
							</div>
							
		
							<div className="btnWrap">
								<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
									검색
								</button>
							</div>
						</>
					);
				} else if ("tour".indexOf(activeItem) > -1) {
					searchElement = (
						<>
							<div className="inputWrap" style={{ marginRight: "0" }}>
								{this.state.tourList.map((item, idx) => {
									return (
										<div id={item.courseId} className="item" key={idx} onClick={() => this.search(item.courseId)}>
											<span>{item.courseNm}</span>
										</div>
									);
								})}
							</div>
						</>
					);
				}

		return (
			<div id="livingWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">
					<div id="dust" className="item" onClick={(evt) => this.search(evt, activeItem)}>
						<span>미세먼지</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="wifi" className="item" onClick={this.openSearchWrap}>
						<span>와이파이설치현황</span>
						<IoIosArrowForward className="arrow" />
					</div>

					<div id="park" className="item" onClick={this.openSearchWrap}>
						<span>공원 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					{/*<div id="hospital" className="item" onClick={this.openSearchWrap}>
						<span>의료시설 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>*/}
					<div id="weather" className="item" onClick={this.openSearchWrap}>
						<span>기상</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="tour" className="item" onClick={this.openSearchWrap}>
						<span>관광기상</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="bioTop" className="item" onClick={this.openSearchWrap}>
						<span>생태현황지도</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Living);
